<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        large
        ref="Modal"
        title="Parametrização da unidade solicitante"
    >
        <Form
            :data="data"
            :index="index"
            :item="item"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: null,
    }),
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao'),
        }     
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getExames(item) {

            if (!item || item && item.id && isNaN(item.id)) {

                this.$refs.Modal.show()
                return false;
            }

            this.setLoading()

             this.repositories.parametrizacao.getExamesUnidadeSolicitante({id: item.id})
                .then(({ data }) => {

                   item.exames = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$refs.Modal.show()))
        },
        open(index, item) {

            this.index = index
            this.item = item

            this.getExames(item)            
        },
        handleExit(data) {

            this.$emit('save', data)

            this.$refs.Modal.hide()
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        data: { type: Object, required: true },
    }
}
</script>